import React from 'react';
import {isPitchAble, pitchLimits, restCheck, total} from "../../simulationFunctions";
import {PitchResult, SimulationData} from "../../simulationTypes";
import {borderBottomStyle, borderSideStyle} from "./tableStyles";
import {RuleType} from "../../RuleType";
import {modifySimInAnotherGameTsx, rest} from "./tableFunctions";

type Props = {
  simulation: SimulationData;
  simulations: SimulationData[];
  setSimulations: React.Dispatch<React.SetStateAction<SimulationData[]>>;
  targetDay: number;
  targetResult: PitchResult;
  rule: RuleType
}

const AnotherGame: React.VFC<Props> = (props) => {
  const limit = pitchLimits(props.rule);
  
  return (
    <>
      <td className={borderBottomStyle + (isPitchAble(props.simulation, props.targetDay, 1, props.rule) ? '':'bg-gray-400')}>
        {isPitchAble(props.simulation, props.targetDay, 1, props.rule) ? (
          <input
            type="number"
            min="0"
            className='pl-2 w-14 text-2xl font-bold bg-transparent text-center'
            value={props.targetResult.pitch_1 ? props.targetResult.pitch_1: ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const newData = props.simulations.map((simulationData) => {
                // チェックする目標日で分岐させて、その投球数と翌日の球数を更新
                if(simulationData.id === props.simulation.id)
                  return modifySimInAnotherGameTsx(simulationData, e.target.value, props.rule, props.simulation, props.targetDay, 1)
                return simulationData;
              });
              props.setSimulations([...newData]);
            }}
          />
        ):(
          ''
        )}
      </td>
      <td className={borderBottomStyle + borderSideStyle + (isPitchAble(props.simulation, props.targetDay, 2, props.rule) ? '':'bg-gray-400')}>
        {isPitchAble(props.simulation, props.targetDay, 2, props.rule) ? (
          <input
            type="number"
            min="0"
            className='pl-2 w-14 text-2xl font-bold bg-transparent text-center'
            value={props.targetResult.pitch_2 ? props.targetResult.pitch_2: '' }
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const newData = props.simulations.map((simulationData) => {
                // チェックする目標日で分岐させて、その投球数と翌日の球数を更新
                if(simulationData.id === props.simulation.id)
                  return modifySimInAnotherGameTsx(simulationData, e.target.value, props.rule, props.simulation, props.targetDay, 2)
                return simulationData;
              });
              props.setSimulations([...newData]);
            }}
          />
        ):(
          ''
        )}
      </td>
      <td className={'text-2xl font-bold text-center ' + borderBottomStyle + borderSideStyle}>
        {total(props.targetResult)}
      </td>
      <td className={'text-2xl font-bold text-center ' + borderBottomStyle + borderSideStyle + (restCheck(props.targetResult) <= 0 ? 'text-white bg-gray-500 border-r-white' : '')}>
        {rest(props.simulation, props.targetResult, props.targetDay, limit, props.rule) <=0 ? 'NO' : rest(props.simulation, props.targetResult, props.targetDay, limit, props.rule)}
      </td>
      <td className={'text-2xl font-bold text-center ' + borderBottomStyle + borderSideStyle+ (props.targetResult.limit === limit.oneDay ? 'bg-blue-200' : props.targetResult.limit > limit.threeGames ? 'bg-green-300': props.targetResult.limit > 0 ? 'bg-orange-300':'text-white bg-red-500')}>
        {props.targetResult.limit ? props.targetResult.limit : 'NO'}
      </td>
    </>
  );
};

export default AnotherGame;
